/* NookPalace theme. Vanilla, no dependencies, deferred.
   Handles: cart drawer + Shopify AJAX cart, variant selection (character x pack),
   order bumps, live add-to-cart total, free-shipping progress, sticky bar,
   accordions, reveal-on-scroll, exit intent and the post-add upsell. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.NP || {};
  CFG.routes = CFG.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var money = function (cents) {
    var v = (cents / 100);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };

  /* ------------------------------------------------------------ cart */
  var SHIP_THRESHOLD = (CFG.freeShipThreshold || 4500);
  var cartState = { items: [], total: 0, count: 0 };

  function paintShipBars(total) {
    var remaining = Math.max(0, SHIP_THRESHOLD - total);
    $$('[data-ship-msg]').forEach(function (el) {
      el.innerHTML = remaining > 0
        ? "You're <strong>" + money(remaining) + '</strong> away from free shipping'
        : '<strong>Free shipping unlocked.</strong>';
      el.classList.toggle('is-complete', remaining === 0);
    });
    $$('[data-ship-fill]').forEach(function (el) {
      el.style.width = Math.min(100, (total / SHIP_THRESHOLD) * 100) + '%';
    });
  }

  function renderCart(cart) {
    cartState = { items: cart.items || [], total: cart.total_price || 0, count: cart.item_count || 0 };
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cartState.count;
      el.hidden = cartState.count === 0;
    });
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cartState.total); });
    paintShipBars(cartState.total);

    var list = $('[data-cart-lines]');
    if (list) {
      list.innerHTML = cartState.items.map(function (li) {
        var img = li.image ? li.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        return '<li class="cart-line" data-key="' + li.key + '">' +
          (img ? '<img src="' + img + '" alt="' + (li.title || '').replace(/"/g, '') + '" width="60" height="60" loading="lazy">' : '') +
          '<div><p class="cart-line__name">' + li.product_title + '</p>' +
          '<p class="cart-line__meta">' + (li.variant_title && li.variant_title !== 'Default Title' ? li.variant_title : '') + '</p>' +
          '<div class="cart-line__qty">' +
            '<button type="button" data-qty="-1" aria-label="Decrease quantity">-</button>' +
            '<span>' + li.quantity + '</span>' +
            '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
          '</div></div>' +
          '<span class="cart-line__price">' + money(li.final_line_price) + '</span></li>';
      }).join('');
    }
    $$('[data-cart-empty]').forEach(function (el) { el.hidden = cartState.count > 0; });
    $$('[data-cart-filled]').forEach(function (el) { el.hidden = cartState.count === 0; });
  }

  function fetchCart() {
    return fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function showCartError(msg) {
    var box = $('[data-cart-error]');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
    setTimeout(function () { box.hidden = true; }, 6000);
  }

  function addToCart(lines) {
    var btns = $$('[data-atc]');
    btns.forEach(function (b) { b.disabled = true; });
    return fetch(CFG.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { showCartError(res.d.description || 'That item could not be added.'); openCart(); return null; }
        return fetchCart().then(function () { return res.d; });
      })
      .catch(function () { showCartError('Something went wrong. Please try again.'); })
      .then(function (v) { btns.forEach(function (b) { b.disabled = false; }); return v; });
  }

  function changeLine(key, qty) {
    return fetch(CFG.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function openCart() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.classList.add('is-open');
    d.removeAttribute('inert');
    document.body.classList.add('no-scroll');
  }
  function closeCart() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('inert', '');
    document.body.classList.remove('no-scroll');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-drawer-scrim]')) { e.preventDefault(); closeCart(); }
    if (e.target.closest('[data-modal-close]')) {
      e.preventDefault();
      var m = e.target.closest('[data-modal]');
      if (m) m.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }
    var qb = e.target.closest('[data-qty]');
    if (qb) {
      var line = qb.closest('.cart-line');
      var cur = cartState.items.filter(function (i) { return i.key === line.dataset.key; })[0];
      if (cur) changeLine(line.dataset.key, cur.quantity + parseInt(qb.dataset.qty, 10));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* --------------------------------------------------- product page */
  var PDP = $('[data-pdp]');
  if (PDP) {
    var VARIANTS = JSON.parse($('[data-variant-json]').textContent);
    var current = VARIANTS.filter(function (v) { return v.id === parseInt(PDP.dataset.selected, 10); })[0] || VARIANTS[0];

    function bumpTotal() {
      return $$('[data-bump]').reduce(function (sum, row) {
        var i = $('input', row);
        return sum + (i && i.checked ? parseInt(row.dataset.price, 10) : 0);
      }, 0);
    }

    function paint() {
      var live = (current ? current.price : 0) + bumpTotal();
      $$('[data-atc-total]').forEach(function (el) { el.textContent = money(live); });
      $$('[data-price-now]').forEach(function (el) { el.textContent = money(current.price); });
      $$('[data-price-was]').forEach(function (el) {
        if (current.compare_at_price && current.compare_at_price > current.price) {
          el.textContent = money(current.compare_at_price); el.hidden = false;
        } else { el.hidden = true; }
      });
      $$('[data-save-pill]').forEach(function (el) {
        if (current.compare_at_price && current.compare_at_price > current.price) {
          var pct = Math.round((1 - current.price / current.compare_at_price) * 100);
          el.textContent = 'Save ' + pct + '%'; el.hidden = false;
        } else { el.hidden = true; }
      });
      paintShipBars(live);

      var atc = $('[data-atc]');
      if (atc) {
        atc.disabled = !current || !current.available;
        var label = $('[data-atc-label]', atc);
        if (label && current && !current.available) label.textContent = 'Sold out';
        else if (label) label.textContent = 'Add to basket - ';
      }
      // keep the URL shareable and correct for back/forward
      if (current && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', u);
      }
    }

    function selectVariant(character, pack) {
      var match = VARIANTS.filter(function (v) {
        return v.option1 === character && v.option2 === pack;
      })[0];
      if (!match) return;
      current = match;

      $$('[data-swatch]').forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.swatch === character);
      });
      $$('[data-swatch-label]').forEach(function (el) { el.textContent = character; });
      $$('[data-bundle-opt]').forEach(function (b) {
        var on = b.dataset.pack === pack;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      // jump the gallery to this character's own photo
      var slide = $('[data-slide-for="' + CSS.escape(character) + '"]');
      var track = $('[data-gal-track]');
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      $$('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.thumbFor === character);
      });

      paint();
    }

    $$('[data-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.getAttribute('aria-disabled') === 'true') return;
        selectVariant(sw.dataset.swatch, current.option2);
      });
    });
    $$('[data-bundle-opt]').forEach(function (b) {
      b.addEventListener('click', function () { selectVariant(current.option1, b.dataset.pack); });
      b.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectVariant(current.option1, b.dataset.pack); }
      });
    });
    // labels wrap the checkbox, so listen for change and never toggle by hand
    $$('[data-bump]').forEach(function (row) {
      var i = $('input', row);
      if (!i) return;
      i.addEventListener('change', function () {
        row.classList.toggle('is-checked', i.checked);
        paint();
      });
      row.classList.toggle('is-checked', i.checked);
    });

    $$('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var track = $('[data-gal-track]');
        var slide = $('[data-slide-for="' + CSS.escape(t.dataset.thumbFor) + '"]');
        if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        $$('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    $$('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        var lines = [{ id: current.id, quantity: 1 }];
        $$('[data-bump]').forEach(function (row) {
          var i = $('input', row);
          if (i && i.checked && row.dataset.variantId) {
            lines.push({ id: parseInt(row.dataset.variantId, 10), quantity: 1 });
          }
        });
        addToCart(lines).then(function (ok) {
          if (!ok) return;
          openCart();
          var up = $('[data-upsell-modal]');
          if (up && !sessionStorage.getItem('np_upsell_seen')) {
            sessionStorage.setItem('np_upsell_seen', '1');
            setTimeout(function () { up.classList.add('is-open'); }, 600);
          }
        });
      });
    });

    paint();
  }

  /* ----------------------------------------------- quick add (grid) */
  $$('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = parseInt(btn.dataset.variantId, 10);
      if (!id) return;
      var label = btn.textContent;
      btn.textContent = 'Adding';
      addToCart([{ id: id, quantity: 1 }]).then(function () {
        btn.textContent = label;
        openCart();
      });
    });
  });

  /* ------------------------------------------------------ accordions */
  $$('[data-accordion]').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      var open = item.classList.contains('is-open');
      var scope = head.closest('[data-accordion-group]');
      if (scope) $$('[data-accordion]', scope).forEach(function (h) { h.parentElement.classList.remove('is-open'); });
      item.classList.toggle('is-open', !open);
      head.setAttribute('aria-expanded', !open ? 'true' : 'false');
    });
  });

  /* ----------------------------------------------------- sticky bar */
  var stickyBar = $('[data-sticky-bar]'), anchor = $('[data-atc-anchor]');
  if (stickyBar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ------------------------------------------------------ rotator */
  $$('[data-rotator]').forEach(function (r) {
    var slides = $$('[data-rotator-slide]', r);
    if (slides.length < 2) return;
    var i = 0;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === 0); });
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      var next = i;
      setTimeout(function () { slides[next].classList.add('is-active'); }, 420);
    }, 4200);
  });

  /* -------------------------------------------------------- reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
    var sweep = function () {
      $$('[data-reveal]').forEach(function (el) {
        if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < window.innerHeight * 1.05) {
          el.classList.add('is-in'); io.unobserve(el);
        }
      });
    };
    window.addEventListener('load', sweep);
    setTimeout(sweep, 400); setTimeout(sweep, 1200);
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* --------------------------------------------------- exit intent */
  var exitModal = $('[data-exit-modal]');
  if (exitModal && !sessionStorage.getItem('np_exit_seen')) {
    var fired = false;
    document.addEventListener('mouseout', function (e) {
      if (fired || e.relatedTarget || e.clientY > 12) return;
      fired = true;
      sessionStorage.setItem('np_exit_seen', '1');
      exitModal.classList.add('is-open');
    });
  }

  /* ------------------------------------------------------ menu + video */
  $$('[data-menu-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var nav = $('[data-mobile-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
  });

  // The hero video is fetched only once the page has loaded and the main thread is
  // idle. Until then the poster <img> stands in, so the video never becomes the LCP
  // candidate and never competes with first paint for bandwidth.
  var hv = $('[data-hero-video]');
  if (hv && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var startHeroVideo = function () {
      if (hv.src) return;
      hv.src = hv.dataset.src;
      hv.addEventListener('playing', function () {
        var wrap = hv.closest('.hero__media');
        if (wrap) wrap.classList.add('is-playing');
      }, { once: true });
      hv.play().catch(function () {});
    };
    var queueHeroVideo = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(startHeroVideo, { timeout: 2500 });
      else setTimeout(startHeroVideo, 1200);
    };
    if (document.readyState === 'complete') queueHeroVideo();
    else window.addEventListener('load', queueHeroVideo);
  }

  fetchCart();
})();
